module.exports = __webpack_public_path__ + "static/media/click1.8befe78b.aac";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/click1.aac
// module id = 486
// module chunks = 0